import React, { useState, useMemo, useCallback } from "react";
import {
  Dropdown,
  ButtonDisclosure,
  Badge,
  DSProvider,
} from "@toddle-edu/ds-web";
import { FilterOutlined } from "@toddle-edu/ds-icons";
import { useI18n } from "Hooks";
import classes from "./StandardsFilter.scss";
import FiltersOverlay from "UIComponents/FiltersOverlay/FiltersOverlay";
import {
  DEFAULT_STANDARD_FILTERS,
  getFilterOverlayOptions,
  getAllFiltersCount,
  getAppliedFiltersCountForFilter,
} from "Post/utils";

const BLANK_ARRAY = [];
const StandardFilter = ({
  subjects = BLANK_ARRAY,
  grades = BLANK_ARRAY,
  tags = BLANK_ARRAY,
  disabled = false,

  setStandardFilters,
  standardFilters,
}) => {
  const { t } = useI18n(["common"]);
  const [showDropdown, setShowDropdown] = useState(false);

  const filterOverlayOptions = getFilterOverlayOptions({
    t,
    grades,
    subjects,
    tags,
  });
  const appliedFiltersCount = useMemo(
    () => getAllFiltersCount({ currentFilters: standardFilters }),
    [standardFilters]
  );

  const onApplyFilterOverlay = useCallback(({ filters }) => {
    setStandardFilters(filters);
    setShowDropdown(false);
  }, []);

  const onCloseFilterOverlay = useCallback(() => setShowDropdown(false), []);
  const getPopupContainer = useCallback(() => document.body, []);

  const filtersOverlayComponent = useMemo(
    () => (
      <FiltersOverlay
        options={filterOverlayOptions}
        currentFilters={standardFilters}
        getAllFiltersCount={getAllFiltersCount}
        getAppliedFiltersCountForFilter={getAppliedFiltersCountForFilter}
        onApply={onApplyFilterOverlay}
        handleClose={onCloseFilterOverlay}
        defaultFilters={DEFAULT_STANDARD_FILTERS}
      />
    ),
    [
      filterOverlayOptions,
      standardFilters,
      onApplyFilterOverlay,
      onCloseFilterOverlay,
    ]
  );
  return (
    <DSProvider dsVersion="2.0">
      <div className={classes.container}>
        <Dropdown
          placement="bottomLeft"
          visible={showDropdown}
          disabled={disabled}
          onVisibleChange={setShowDropdown}
          getPopupContainer={getPopupContainer}
          overlay={filtersOverlayComponent}
        >
          <ButtonDisclosure
            icon={<FilterOutlined />}
            type="outlined"
            variant="neutral"
            size="medium"
            testId="standardFilter-button"
            dsVersion="2.0"
          >
            {appliedFiltersCount > 0 ? (
              <span className={classes.filterBtn}>
                <Badge
                  value={appliedFiltersCount}
                  type="numeric"
                  variant="dark"
                  shape="circle"
                />
              </span>
            ) : null}
          </ButtonDisclosure>
        </Dropdown>
      </div>
    </DSProvider>
  );
};

export default StandardFilter;
